import React from 'react';
import { Navigate } from 'react-router';

import { LoansOverview } from 'packages/loans/ui/LoansOverview';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';

const RouteBase = () => {
  return <LoansOverview />;
};

export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/" />;
      }}
    >
      <RouteBase />
    </RouteErrorBoundary>
  );
};
